const Checkbox = {
  set(checkbox, state) {
    checkbox.prop("checked", state)
    if (state) {
      return checkbox.val(1)
    } else {
      return checkbox.val(0)
    }
  }
}

export default Checkbox
